import { jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';
import { BaseIcon } from '../../../components/base-icon.mjs';

const SvgSplitCells = forwardRef((props, ref) => /* @__PURE__ */ jsx(BaseIcon, { fill: "none", ref, ...props, children: /* @__PURE__ */ jsx(
  "path",
  {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M4 18v2h6V4H4v2m16 12v2h-6V4h6v2M6.495 14.495 4 12m0 0 2.495-2.495M4 12h5.948m7.498 2.554L20 12m0 0-2.554-2.554M20 12h-5.832"
  }
) }));

export { SvgSplitCells as default };
//# sourceMappingURL=split-cells.mjs.map
